import { useQuery } from '@tanstack/react-query';

import { useDonationContext } from 'hb-react/frontoffice/contexts/DonationContext';
import { useDefaultAppContexts } from 'hb-react/frontoffice/contexts/withDefaultAppContexts';

import fetchDonations from '../requests/fetchDonations';

const useDonations = ({ enabled = false } = {}) => {
  const { whitelabelURL } = useDonationContext();
  const { currentUser } = useDefaultAppContexts();
  // Never enabled whitelabelURL if the user is connected
  const whitelabelURLEnabled = currentUser ? false : whitelabelURL;
  const donationPath = whitelabelURLEnabled
    ? '?format=json'
    : Routes.donations_path({ format: 'json' });

  const { status, data } = useQuery({
    queryKey: ['donations'],
    queryFn: fetchDonations(donationPath),
    enabled,
  });

  return {
    status,
    donations: data?.donations,
  };
};

export default useDonations;
